import React from 'react';
import Link from 'react-router-dom/Link';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const LinkWithSearch = ({
  pathname,
  location: { search },
  // removes staticContext from the props that are being passed down to prevent a React warning
  staticContext, // eslint-disable-line
  ...args
}) => {
  return (
    <Link to={{ pathname, search }} {...args}>
      {args.children}
    </Link>
  );
};

LinkWithSearch.propTypes = {
  pathname: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default withRouter(LinkWithSearch);
